var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { SocialError } from 'core/domain/common';
import { inject, injectable } from 'inversify';
import { FirestoreClientTypes } from '../../firestoreClientTypes';
import { Graph } from 'core/domain/graphs';
/**
 * Firbase user service
 *
 * @export
 * @class UserTieService
 * @implements {IUserTieService}
 */
var UserTieService = /** @class */ (function () {
    function UserTieService(_graphService) {
        var _this = this;
        this._graphService = _graphService;
        /**
         * Tie users
         */
        this.tieUseres = function (userTieSenderInfo, userTieReceiveInfo, circleIds) {
            return new Promise(function (resolve, reject) {
                _this._graphService
                    .addGraph(new Graph(userTieSenderInfo.userId, 'TIE', userTieReceiveInfo.userId, __assign({}, userTieSenderInfo), __assign({}, userTieReceiveInfo), { creationDate: Date.now(), circleIds: circleIds }), 'users').then(function (result) {
                    resolve();
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/tieUseres :' + error.message)); });
            });
        };
        /**
         * Update users tie
         */
        this.updateUsersTie = function (userTieSenderInfo, userTieReceiveInfo, circleIds) {
            return new Promise(function (resolve, reject) {
                _this._graphService
                    .updateGraph(new Graph(userTieSenderInfo.userId, 'TIE', userTieReceiveInfo.userId, __assign({}, userTieSenderInfo), __assign({}, userTieReceiveInfo), { creationDate: Date.now(), circleIds: circleIds }), 'users').then(function () {
                    resolve();
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/updateUsersTie :' + error.message)); });
            });
        };
        /**
         * Remove users' tie
         */
        this.removeUsersTie = function (firstUserId, secondUserId) {
            return new Promise(function (resolve, reject) {
                _this.getUserTiesWithSeconUser(firstUserId, secondUserId).then(function (userTies) {
                    if (userTies.length > 0) {
                        _this._graphService.deleteGraphByNodeId(userTies[0].nodeId).then(resolve);
                    }
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/removeUsersTie :' + error.message)); });
            });
        };
        /**
         * Get user ties
         */
        this.getUserTies = function (userId) {
            return new Promise(function (resolve, reject) {
                _this._graphService
                    .getGraphs('users', userId, 'TIE')
                    .then(function (result) {
                    var parsedData = {};
                    result.forEach(function (node) {
                        var _a;
                        var leftUserInfo = node.LeftMetadata;
                        var rightUserInfo = node.rightMetadata;
                        var metadata = node.graphMetadata;
                        parsedData = __assign({}, parsedData, (_a = {}, _a[rightUserInfo.userId] = __assign({}, rightUserInfo, { circleIdList: metadata ? metadata.circleIds : [] }), _a));
                    });
                    resolve(parsedData);
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/getUserTies :' + error.message)); });
            });
        };
        /**
         * Get the users who tied current user
         */
        this.getUserTieSender = function (userId) {
            return new Promise(function (resolve, reject) {
                _this._graphService
                    .getGraphs('users', null, 'TIE', userId)
                    .then(function (result) {
                    var parsedData = {};
                    result.forEach(function (node) {
                        var _a;
                        var leftUserInfo = node.LeftMetadata;
                        var rightUserInfo = node.rightMetadata;
                        var metada = node.graphMetadata;
                        parsedData = __assign({}, parsedData, (_a = {}, _a[leftUserInfo.userId] = __assign({}, leftUserInfo, { circleIdList: [] }), _a));
                    });
                    resolve(parsedData);
                })
                    .catch(function (error) { return reject(new SocialError(error.code, 'firestore/getUserTieSender :' + error.message)); });
            });
        };
        /**
         * Get user ties with second user identifier
         */
        this.getUserTiesWithSeconUser = function (userId, secondUserId) {
            return new Promise(function (resolve, reject) {
                _this._graphService
                    .getGraphs('users', userId, 'TIE', secondUserId).then(resolve)
                    .catch(reject);
            });
        };
    }
    UserTieService = __decorate([
        injectable(),
        __param(0, inject(FirestoreClientTypes.GraphService))
    ], UserTieService);
    return UserTieService;
}());
export { UserTieService };



//////////////////
// WEBPACK FOOTER
// ./src/data/firestoreClient/services/circles/UserTieService.ts
// module id = 660
// module chunks = 50